import { useEffect, useState } from 'react';
import unitLabelService from '/src/services/unitLabelService';

function useUnitLabels() {
    const [unitLabels, setUnitLabels] = useState([]);
    const [labelByUnitId, setLabelByUnitId] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        let isMounted = true;

        const fetchUnitLabels = async () => {
            const [response, error] = await unitLabelService.getUnitLabelsCached();
            if (!isMounted || error || !response) return;

            const data = response.data || [];
            setUnitLabels(data);
            setLabelByUnitId(Object.fromEntries(data.map((u) => [u.unit_id, u.label])));
        };

        fetchUnitLabels().finally(() => {
            if (isMounted) setIsLoading(false);
        });

        return () => { isMounted = false; };
    }, []);

    const getLabel = (unitId) => labelByUnitId[unitId] || (unitId?.replace(/^anytech365-/, "") ?? "");

    return { unitLabels, labelByUnitId, getLabel, isLoading };
}

export default useUnitLabels;
